export default "__VITE_ASSET__DfO8sHnq__"